import caller from './homeCaller'

export const showHideSearchBarMobile = (showHide) => {
  caller.toggleSearchMobile(showHide)
}